import Component from '@glimmer/component';
import type { MapboxArgs } from '../../modifiers/mapbox';

export interface MapSignature {
  Args: MapboxArgs;
  Element: HTMLDivElement;
}

export default class MapComponent extends Component<MapSignature> {
  get center() {
    return this.args.center || this.args.coordinates?.[this.args.coordinates.length - 1];
  }

  get style() {
    return this.args.style || 'mapbox://styles/mapbox/light-v11';
  }

  get zoom() {
    return this.args.zoom || 12;
  }
}
